import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import HelpCategory from '../../../../domain/entities/writer/HelpCategory';

export default function reducer(
  state: {[key: number]: HelpCategory} = {},
  action: AnyAction,
): {[key: number]: HelpCategory} {
  switch (action.type) {
    case Types.IndexWriterHelpCategoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: HelpCategory}, record: HelpCategory) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowWriterHelpCategorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
